import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';
import {Phase} from '../home-page/model/phase';

export class Gps {

  public latitude: string;
  public longitude: string;

  constructor() {
    this.latitude = "";
    this.longitude = "";
  }

  clone(data: Gps){
    this.longitude = data.longitude;
    this.latitude = data.latitude;
  }

  fromJson(data: Gps) {
    this.latitude = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.latitude], '');
    this.longitude = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.longitude], '');
  }

  toMap() {
    return {

      'lat': this.latitude.toString(),
      "lon" : this.longitude.toString()
    };
  }
}
